import { Fragment } from 'preact'

export const Plan = ({ plan, title }) => {
  return (
    <Fragment>
      {plan ? (
        <div dangerouslySetInnerHTML={{ __html: replaceServiceName(plan, title) }}></div>
      ) : (
        <div>
          <p>
            Orange s'engage à rendre ses sites internet, intranet, extranet, ses progiciels, ses applications mobiles et mobilier urbain numérique accessibles&nbsp;conformément à
            l'article 47 de la loi n°2005-102 du 11 février 2005.
          </p>
          <p>
            À cette fin,&nbsp;Orange&nbsp;met en œuvre la stratégie et les actions suivantes&nbsp;:{' '}
            <a
              href="https://oran.ge/accessibilite-schema"
              title="schéma pluriannuel d'amélioration de l'accessibilité numérique 2024-2026 (PDF, 230Ko - nouvelle fenêtre)"
              target="_blank"
            >
              Schéma pluriannuel d'amélioration de l'accessibilité numérique 2024-2026 (PDF, 230Ko)
            </a>
            .
          </p>
          {title ? <p>Cette déclaration d'accessibilité s'applique à {title}.</p> : ''}
        </div>
      )}
    </Fragment>
  )
}

const replaceServiceName = (plan, title) => {
  return plan.replace(/\[nom du service concerné\]/g, title)
}
